import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { isNativeAppBoth } from './userAgentUtil';

export const getDeviceName = (userAgent: string) => {
  if (isNativeAppBoth(userAgent)) {
    if (isIOS) {
      return 'iOS';
    }
    if (isAndroid) {
      return 'Android';
    }
    return '';
  }
  if (isMobile) {
    return 'Mobile';
  }
  return 'PC';
};

export const getIsMobile = (userAgent: string): boolean =>
  /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent
  );

export const getByteplusPlatform = (isNative: boolean) => {
  if (isNative) {
    return 'app';
  }
  return isMobile ? 'mobile_web' : 'desktop_web';
};
